import PropTypes from 'prop-types'
// styles
import './searchButton.scss'
// hooks
import useRouterControl from '../../../../../hooks/useRouterControl'
// icons
import { SearchIcon } from '../../../../../components/atoms/icons'
// list routes
import listRoutes from '../../../../../routes/listRoutes'
import Tooltip from 'components/atoms/tooltip/tooltip'

const SearchButton = ({ className, textTooltip, link = listRoutes.programSearch }) => {
	const { routerControl } = useRouterControl()

	return (
		<button className={className} onClick={() => routerControl({ link })}>
			{textTooltip && (
				<Tooltip
					closeIcon={false}
					styles={{
						base: {
							top: '-6.5rem',
							right: '1rem',
							width: '200px',
							fontSize: '1.3rem',
							padding: '8px 25px',
							minWidth: '200px'
						},
						mark: { right: '1rem', bottom: '-9px' }
					}}
					isActive
				>
					{textTooltip}
				</Tooltip>
			)}
			<SearchIcon color='#ee2b7b' />
		</button>
	)
}

SearchButton.propTypes = {
	className: PropTypes.oneOf(['t-a-search-button', 't-a-search-button-initial-position'])
}

SearchButton.defaultProps = {
	className: 't-a-search-button'
}

export default SearchButton
